/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresignedUrlResponse
 */
export interface PresignedUrlResponse {
    /**
     * Url to shared/upload an object
     * @type {string}
     * @memberof PresignedUrlResponse
     */
    url: string;
}

/**
 * Check if a given object implements the PresignedUrlResponse interface.
 */
export function instanceOfPresignedUrlResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "url" in value;

    return isInstance;
}

export function PresignedUrlResponseFromJSON(json: any): PresignedUrlResponse {
    return PresignedUrlResponseFromJSONTyped(json, false);
}

export function PresignedUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresignedUrlResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function PresignedUrlResponseToJSON(value?: PresignedUrlResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}

